import request from '@/utils/request'


// 查询动态举报记录列表
export function listDynamicReport(query) {
  return request({
    url: '/dynamic/dynamicReport/list',
    method: 'get',
    params: query
  })
}

// 查询动态举报记录分页
export function pageDynamicReport(query) {
  return request({
    url: '/dynamic/dynamicReport/page',
    method: 'get',
    params: query
  })
}

// 查询动态举报记录详细
export function getDynamicReport(data) {
  return request({
    url: '/dynamic/dynamicReport/detail',
    method: 'get',
    params: data
  })
}

// 新增动态举报记录
export function addDynamicReport(data) {
  return request({
    url: '/dynamic/dynamicReport/add',
    method: 'post',
    data: data
  })
}

// 修改动态举报记录
export function updateDynamicReport(data) {
  return request({
    url: '/dynamic/dynamicReport/edit',
    method: 'post',
    data: data
  })
}

// 删除动态举报记录
export function delDynamicReport(data) {
  return request({
    url: '/dynamic/dynamicReport/delete',
    method: 'post',
    data: data
  })
}
